export interface PartnerOffer {
    subtitle: string;
    intro: string;
    benefits: string[];
    howToTitle: string;
    steps?: string[];
    code?: string;
    codeLabel?: string;
    noteLines?: string[];
    helpTitle?: string;
    helpEmail?: string;
    helpPhone?: string;
    helpLink?: { label: string; url: string };
}

export interface PartnerData {
    id: number;
    name: string;
    description: string;
    image: string;
    offer?: PartnerOffer;
}

export const partners: PartnerData[] = [
    {
        id: 1,
        name: 'SJ',
        description: 'PARTNER_PAGE_DESCRIPTION_SJ',
        image: '/assets/png/SJ-logo.png',
        offer: {
            subtitle: 'PARTNER_OFFER_SJ_SUBTITLE',
            intro: 'PARTNER_OFFER_SJ_INTRO',
            benefits: [
                'PARTNER_OFFER_SJ_BENEFIT_1',
                'PARTNER_OFFER_SJ_BENEFIT_2',
                'PARTNER_OFFER_SJ_BENEFIT_3',
            ],
            howToTitle: 'PARTNER_OFFER_SJ_HOW_TO_TITLE',
            steps: [
                'PARTNER_OFFER_SJ_STEP_1',
                'PARTNER_OFFER_SJ_STEP_2',
                'PARTNER_OFFER_SJ_STEP_3',
                'PARTNER_OFFER_SJ_STEP_4',
            ],
            code: '986898',
            codeLabel: 'PARTNER_OFFER_SJ_CODE_LABEL',
            helpTitle: 'PARTNER_OFFER_SJ_HELP_TITLE',
            helpEmail: 'foretag@sj.se',
            helpPhone: '0771-75 75 55',
            helpLink: { label: 'PARTNER_OFFER_SJ_HELP_LINK_LABEL', url: 'https://www.sj.se/en' },
        },
    },
    {
        id: 2,
        name: 'SAS',
        description: 'PARTNER_PAGE_DESCRIPTION_SAS',
        image: '/assets/svg/SAS-logo.svg',
        offer: {
            subtitle: 'PARTNER_OFFER_SAS_SUBTITLE',
            intro: 'PARTNER_OFFER_SAS_INTRO',
            benefits: [
                'PARTNER_OFFER_SAS_BENEFIT_1',
                'PARTNER_OFFER_SAS_BENEFIT_2',
                'PARTNER_OFFER_SAS_BENEFIT_3',
            ],
            howToTitle: 'PARTNER_OFFER_SAS_HOW_TO_TITLE',
            steps: [
                'PARTNER_OFFER_SAS_STEP_1',
            ],
            code: '1000754',
            codeLabel: 'PARTNER_OFFER_SAS_CODE_LABEL',
            helpTitle: 'PARTNER_OFFER_SAS_HELP_TITLE',
            helpEmail: 'corporatesupport@sas.se',
            helpPhone: '+372 6682445',
            helpLink: { label: 'PARTNER_OFFER_SAS_HELP_LINK_LABEL', url: 'https://www.flysas.com/en' },
        },
    },
    {
        id: 3,
        name: 'SATS',
        description: 'PARTNER_PAGE_DESCRIPTION_SATS',
        image: '/assets/jpg/SATS-Logo.jpg',
        offer: {
            subtitle: 'PARTNER_OFFER_SATS_SUBTITLE',
            intro: 'PARTNER_OFFER_SATS_INTRO',
            benefits: [
                'PARTNER_OFFER_SATS_BENEFIT_1',
                'PARTNER_OFFER_SATS_BENEFIT_2',
                'PARTNER_OFFER_SATS_BENEFIT_3',
            ],
            howToTitle: 'PARTNER_OFFER_SATS_HOW_TO_TITLE',
            steps: [
                'PARTNER_OFFER_SATS_STEP_1',
            ],
            code: '500p642139rpt1',
            codeLabel: 'PARTNER_OFFER_SATS_CODE_LABEL',
            noteLines: [
                'PARTNER_OFFER_SATS_NOTE_1',
                'PARTNER_OFFER_SATS_NOTE_2',
            ],
            helpTitle: 'PARTNER_OFFER_SATS_HELP_TITLE',
            helpLink: { label: 'PARTNER_OFFER_SATS_HELP_LINK_LABEL', url: 'https://www.sats.se/' },
        },
    },
    {
        id: 4,
        name: 'Tallink Silja Line',
        description: 'PARTNER_PAGE_DESCRIPTION_SILJA',
        image: '/assets/png/Silja-Logo.png',
        offer: {
            subtitle: 'PARTNER_OFFER_SILJA_SUBTITLE',
            intro: 'PARTNER_OFFER_SILJA_INTRO',
            benefits: [
                'PARTNER_OFFER_SILJA_BENEFIT_1',
                'PARTNER_OFFER_SILJA_BENEFIT_2',
                'PARTNER_OFFER_SILJA_BENEFIT_3',
            ],
            howToTitle: 'PARTNER_OFFER_SILJA_HOW_TO_TITLE',
            steps: [
                'PARTNER_OFFER_SILJA_STEP_1',
            ],
            code: 'INVOZIO25',
            codeLabel: 'PARTNER_OFFER_SILJA_CODE_LABEL',
            noteLines: [
                'PARTNER_OFFER_SILJA_NOTE_1',
                'PARTNER_OFFER_SILJA_NOTE_2',
                'PARTNER_OFFER_SILJA_NOTE_3',
            ],
            helpTitle: 'PARTNER_OFFER_SILJA_HELP_TITLE',
            helpLink: { label: 'PARTNER_OFFER_SILJA_HELP_LINK_LABEL', url: 'https://www.tallinksilja.com' },
        },
    },
];